function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_31005",
  "data-name": "Group 31005"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5362",
  "data-name": "Rectangle 5362",
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5363",
  "data-name": "Rectangle 5363",
  width: 24,
  height: 24,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_31006",
  "data-name": "Group 31006"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60655",
  "data-name": "Path 60655",
  d: "M23,12,20.56,9.21l.34-3.69L17.29,4.7,15.4,1.5,12,2.96,8.6,1.5,6.71,4.69,3.1,5.5l.34,3.7L1,12l2.44,2.79-.34,3.7,3.61.82L8.6,22.5,12,21.03l3.4,1.46,1.89-3.19,3.61-.82-.34-3.69ZM9.38,16.01,7,13.61A1,1,0,0,1,7,12.2l.07-.07a1.008,1.008,0,0,1,1.42,0l1.61,1.62,5.15-5.16a1.008,1.008,0,0,1,1.42,0l.07.07a1,1,0,0,1,0,1.41l-5.92,5.94A1.032,1.032,0,0,1,9.38,16.01Z"
}));

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "verified_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.d6d8bb63.svg";
export { ForwardRef as ReactComponent };